import { render, staticRenderFns } from "./ConsentIdentityForm.vue?vue&type=template&id=6c58ff00&scoped=true&"
import script from "./ConsentIdentityForm.vue?vue&type=script&lang=ts&"
export * from "./ConsentIdentityForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58ff00",
  null
  
)

export default component.exports